





























import { Component, Vue } from 'vue-property-decorator';
import CBtn from '@web/components/CBtn.vue';
import RouterHelper from '@shared/helpers/router.helper';
import { EModes } from '@shared/models/Enums/EModes';
import AppLoginLayout from '@shared/views/LoginLayouts/Layout.vue';

const routerHelper = new RouterHelper();

@Component({
  components: {
    AppLoginLayout,
    CBtn,
  },
})
export default class Signup extends Vue {
  public mode = EModes.Parents;

  public accountTypes = [
    {
      label: "I'm a parent",
      link: routerHelper.signup().parent().getRoute(),
    },
    {
      label: "I'm an organization",
      link: routerHelper.signup().organization().getRoute(),
    },
  ];

  public currentLink = '';

  next() {
    if (!this.currentLink) return;
    this.$router.push(this.currentLink);
  }
}
